
(function(){
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const body=document.body;
  const standardPanels = '.nav-drawer,.utility-drawer,.filter-drawer';
  function setOpen(el,open){
    if(!el)return;
    el.classList.toggle('panel-hidden',!open);
    el.setAttribute('aria-hidden', open?'false':'true');
  }
  function overlay(){return $('#drawer-backdrop')}
  function anyPanel(){
    const standardOpen = $$(standardPanels).some(el => !el.classList.contains('panel-hidden'));
    const cart = $('#CartDrawer');
    const cartOpen = !!(cart && cart.classList.contains('open'));
    return standardOpen || cartOpen;
  }
  function syncLock(){
    const open = anyPanel();
    body.classList.toggle('drawer-open',open);
    const b=overlay();
    if(b){
      b.classList.toggle('panel-hidden',!open);
      b.setAttribute('aria-hidden',open?'false':'true');
    }
  }
  function closePanels(){
    // Close every slide-out surface first. Do not infer the closed state from
    // CartDrawer because the cart uses `.open`, not `.panel-hidden`.
    $$(standardPanels).forEach(el=>setOpen(el,false));
    const c=$('#CartDrawer');
    if(c){
      c.classList.remove('open');
      c.setAttribute('aria-hidden','true');
    }
    $$('.nav-item.is-open').forEach(el=>el.classList.remove('is-open'));

    // Deterministic cleanup: a stale body lock/backdrop is what made the
    // storefront appear frozen after Search/Wishlist/Menu was closed.
    body.classList.remove('drawer-open');
    const b=overlay();
    if(b){
      b.classList.add('panel-hidden');
      b.setAttribute('aria-hidden','true');
    }
  }
  document.addEventListener('click',e=>{
    const open=e.target.closest('[data-open-panel]'); if(open){e.preventDefault(); closePanels(); const el=$(open.dataset.openPanel); if(el){ if(el.id==='CartDrawer'){el.classList.add('open');el.setAttribute('aria-hidden','false');} else setOpen(el,true); syncLock(); } return;}
    if(e.target.closest('[data-close-panels]')){e.preventDefault();closePanels();return;}
    const mega=e.target.closest('[data-mega-toggle]'); if(mega){e.preventDefault(); const item=mega.closest('.nav-item'); const was=item.classList.contains('is-open'); $$('.nav-item.is-open').forEach(x=>x.classList.remove('is-open')); item.classList.toggle('is-open',!was); return;}
    const q=e.target.closest('[data-quick-toggle]'); if(q){e.preventDefault(); const card=q.closest('.product-card'); const panel=$('.quick-size-panel',card); if(panel)panel.hidden=!panel.hidden; return;}
    const qc=e.target.closest('[data-quick-close]'); if(qc){e.preventDefault(); const p=qc.closest('.quick-size-panel'); if(p)p.hidden=true;return;}
    const variant=e.target.closest('[data-variant-id]'); if(variant){e.preventDefault(); const form=variant.closest('form'); if(!form)return; const input=$('input[name="id"]',form); if(input)input.value=variant.dataset.variantId; $$('.size-options button',form).forEach(x=>x.classList.remove('active')); variant.classList.add('active'); const price=$('[data-product-price]',form.closest('.pdp-info')); if(price&&variant.dataset.price)price.textContent=variant.dataset.price; return;}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closePanels()});
  $$('.nav-item').forEach(item=>{item.addEventListener('mouseleave',()=>item.classList.remove('is-open'))});
  document.addEventListener('change',e=>{const s=e.target.closest('[data-sort-select]'); if(s){const u=new URL(location.href);u.searchParams.set('sort_by',s.value);location.href=u.toString();}});
  async function refreshCart(open=true){
    try{const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});const cart=await r.json(); $$('[data-cart-count]').forEach(x=>x.textContent=cart.item_count||0); const bodyEl=$('[data-cart-body]'), total=$('[data-cart-total]'); if(total)total.textContent=Shopify.formatMoney?Shopify.formatMoney(cart.total_price):'₹'+(cart.total_price/100).toLocaleString('en-IN'); if(bodyEl){ if(!cart.items.length)bodyEl.innerHTML='<p class="cart-empty">Your cart is empty.</p>'; else bodyEl.innerHTML=cart.items.map(i=>`<div class="cart-drawer-line"><a href="${i.url}"><img src="${i.image||''}" alt=""></a><div><a href="${i.url}"><h3>${escapeHtml(i.product_title)}</h3></a><p>${escapeHtml(i.variant_title||'')}</p><strong>${formatMoney(i.final_line_price)}</strong><p>Qty ${i.quantity}</p><button class="text-button" data-remove-key="${i.key}">Remove</button></div></div>`).join(''); } if(open){const d=$('#CartDrawer');if(d){d.classList.add('open');d.setAttribute('aria-hidden','false');}syncLock();}}
    catch(err){console.error(err)}
  }
  function formatMoney(c){return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format((c||0)/100)}
  function escapeHtml(s){return String(s||'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]))}
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('[data-ajax-cart-form], .js-ajax-cart-form'); if(!form)return; const submitter=e.submitter; if(submitter && !submitter.classList.contains('add-to-cart') && !form.closest('.quick-size-panel')) return; e.preventDefault(); const error=$('.product-form-error',form); if(error)error.textContent=''; try{const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)}); if(!res.ok)throw new Error((await res.json()).description||'Unable to add item'); await refreshCart(true); const panel=form.closest('.quick-size-panel'); if(panel)panel.hidden=true;}catch(err){if(error)error.textContent=err.message;else alert(err.message)}});
  document.addEventListener('click',async e=>{const rm=e.target.closest('[data-remove-key]');if(!rm)return;e.preventDefault();await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:rm.dataset.removeKey,quantity:0})});refreshCart(false)});
  window.SixToGo={refreshCart,closePanels};
})();


/* 6ix to Go policy-page progressive enhancement */
(function(){
  function slugify(s){return String(s||'').toLowerCase().replace(/^\s*\d+[.)]?\s*/, '').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,80)}
  document.querySelectorAll('[data-policy-page]').forEach(page=>{
    const content=page.querySelector('[data-policy-content]');
    const toc=page.querySelector('[data-policy-toc]');
    if(!content||!toc||content.dataset.enhanced==='true')return;
    content.dataset.enhanced='true';
    const children=Array.from(content.children);
    const firstHeading=children.findIndex(el=>el.tagName==='H2');
    if(firstHeading>0){
      const pre=document.createElement('div'); pre.className='policy-preamble';
      children.slice(0,firstHeading).forEach(el=>pre.appendChild(el));
      content.prepend(pre);
    }
    let current=null, count=0;
    Array.from(content.children).forEach(el=>{
      if(el.classList&&el.classList.contains('policy-preamble'))return;
      if(el.tagName==='H2'){
        count++;
        current=document.createElement('section'); current.className='policy-section';
        const raw=el.textContent.trim();
        const clean=raw.replace(/^\s*\d+[.)]?\s*/, '');
        el.textContent=clean;
        const id='policy-'+(slugify(clean)||count); current.id=id;
        content.insertBefore(current,el); current.appendChild(el);
        const a=document.createElement('a');
        a.href='#'+id;
        a.innerHTML='<span>'+String(count).padStart(2,'0')+'</span><b>'+clean+'</b>';
        toc.appendChild(a);
      } else if(current){current.appendChild(el)}
    });
    if(!toc.children.length) page.querySelector('.policy-toc').style.display='none';
    const links=Array.from(toc.querySelectorAll('a'));
    if('IntersectionObserver' in window){
      const obs=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){links.forEach(a=>a.classList.toggle('is-active',a.getAttribute('href')==='#'+entry.target.id))}})},{rootMargin:'-20% 0px -70% 0px'});
      content.querySelectorAll('.policy-section').forEach(s=>obs.observe(s));
    }
  });
})();

/* Native Shopify /policies/* editorial enhancement */
(function(){
  const root=document.querySelector('.shopify-policy__container');
  if(!root || root.dataset.sixEnhanced==='1') return;
  root.dataset.sixEnhanced='1';
  const title=root.querySelector('.shopify-policy__title h1');
  if(!title) return;
  const rawTitle=title.textContent.trim();
  const lower=rawTitle.toLowerCase();
  if(lower==='terms of service') title.textContent='Terms & Conditions';
  if(lower==='refund policy') title.textContent='Return, Exchange & Refund Policy';

  const body=root.querySelector('.shopify-policy__body'); if(!body)return;
  const source=body.querySelector('.rte')||body;
  const fallbacks=document.querySelector('#SixPolicyFallbacks');
  const fallbackKey = lower.includes('privacy') ? 'privacy-policy' :
                      lower.includes('terms') ? 'terms-of-service' :
                      lower.includes('shipping') ? 'shipping-policy' :
                      (lower.includes('refund') || lower.includes('return')) ? 'refund-policy' :
                      lower.includes('contact') ? 'contact-information' : '';
  const fallback=fallbacks && fallbackKey ? fallbacks.querySelector('template[data-policy-fallback="'+fallbackKey+'"]') : null;

  // Shopify can expose a blank/skeletal native policy in theme preview. In that case,
  // use the approved bundled policy copy so the page is never visually empty.
  // The approved legal documents bundled with this theme are the legal-content source of truth.
  // Always render them on Shopify's native /policies/* routes so Shopify's generated/default
  // policy copy cannot replace, truncate, or conflict with the approved documents.
  if(fallback && fallback.innerHTML.trim()) source.innerHTML=fallback.innerHTML;

  Array.from(source.querySelectorAll('p,h2,h3,h4')).forEach(el=>{
    if(/^(last\s*updated|updated\s*on)\s*:?/i.test((el.textContent||'').trim())) el.remove();
  });

  // Promote obvious bold paragraph headings when Shopify has flattened rich text.
  Array.from(source.querySelectorAll('p')).forEach(p=>{
    const text=(p.textContent||'').trim();
    if(!text || text.length>80) return;
    const strong=p.querySelector('strong,b');
    if(strong && strong.textContent.trim()===text){
      const h=document.createElement('h2'); h.innerHTML=p.innerHTML; p.replaceWith(h);
    }
  });

  const shell=document.createElement('div'); shell.className='native-policy-shell';
  const aside=document.createElement('aside'); aside.className='native-policy-toc'; aside.innerHTML='<div class="native-policy-toc-inner"><p class="native-policy-toc-title">ON THIS PAGE</p><nav class="native-policy-toc-list"></nav></div>';
  const content=document.createElement('div'); content.className='native-policy-content';
  const toc=aside.querySelector('nav');
  const slug=s=>String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,70);

  // Flatten into top-level units so nested Shopify wrappers do not hide headings.
  const temp=document.createElement('div'); temp.innerHTML=source.innerHTML;
  const units=[];
  function collect(node){
    Array.from(node.children).forEach(el=>{
      if(el.matches('h2,h3')) units.push(el);
      else if(el.querySelector('h2,h3')) collect(el);
      else units.push(el);
    });
  }
  collect(temp);

  let section=null,count=0;
  const intro=document.createElement('div'); intro.className='native-policy-intro';
  units.forEach(el=>{
    if(el.matches && el.matches('h2,h3')){
      count++;
      section=document.createElement('section'); section.className='native-policy-section'; section.id='legal-'+(slug(el.textContent)||count);
      const n=document.createElement('span'); n.className='native-policy-number'; n.textContent=String(count).padStart(2,'0'); section.appendChild(n);
      const h=document.createElement('h2'); h.innerHTML=el.innerHTML.replace(/^\s*\d+[.)-]?\s*/, ''); section.appendChild(h); content.appendChild(section);
      const a=document.createElement('a'); a.href='#'+section.id; a.innerHTML='<span>'+String(count).padStart(2,'0')+'</span><b>'+h.textContent.trim()+'</b>'; toc.appendChild(a);
    } else if(section){ section.appendChild(el); }
    else { intro.appendChild(el); }
  });

  if(intro.children.length) content.prepend(intro);
  if(!count && fallback && fallback.innerHTML.trim()){
    source.innerHTML=fallback.innerHTML;
    root.dataset.sixEnhanced='0';
    return location.reload();
  }
  source.replaceChildren(shell); shell.append(aside,content);

  const links=Array.from(toc.querySelectorAll('a'));
  if('IntersectionObserver' in window && links.length){
    const obs=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){links.forEach(a=>a.classList.toggle('is-active',a.getAttribute('href')==='#'+entry.target.id));}})},{rootMargin:'-18% 0px -72% 0px'});
    content.querySelectorAll('.native-policy-section').forEach(sec=>obs.observe(sec));
  }
})();

/* 6IX TO GO — wishlist + product hover actions */
(() => {
  const STORAGE_KEY = 'sixToGoWishlistV1';
  const $ = (s, root=document) => root.querySelector(s);
  const $$ = (s, root=document) => Array.from(root.querySelectorAll(s));

  const read = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch { return []; }
  };

  const write = items => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    renderAll();
  };

  const cardData = card => {
    if (!card || !card.dataset.productId) return null;
    let variants = [];
    try { variants = JSON.parse(card.dataset.productVariants || '[]'); } catch {}
    return {
      id: card.dataset.productId,
      title: card.dataset.productTitle || '',
      url: card.dataset.productUrl || '#',
      image: card.dataset.productImage || '',
      price: card.dataset.productPrice || '',
      variants
    };
  };

  const inWishlist = id => read().some(item => String(item.id) === String(id));

  const updateCount = items => {
    $$('[data-wishlist-count]').forEach(el => {
      el.textContent = items.length;
      el.hidden = items.length === 0;
    });
  };

  const updateCardButtons = items => {
    const ids = new Set(items.map(i => String(i.id)));
    $$('[data-wishlist-card]').forEach(card => {
      const active = ids.has(String(card.dataset.productId));
      const btn = $('[data-wishlist-toggle]', card);
      if (!btn) return;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? `Remove ${card.dataset.productTitle} from wishlist` : `Add ${card.dataset.productTitle} to wishlist`);
      btn.innerHTML = active
        ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21 3.2 12.4a5.5 5.5 0 0 1 7.7-7.8L12 5.7l1.1-1.1a5.5 5.5 0 1 1 7.7 7.8L12 21Z"/></svg>'
        : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
    });
  };

  const esc = str => String(str || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  const renderDrawer = items => {
    const body = $('[data-wishlist-body]');
    if (!body) return;

    if (!items.length) {
      body.innerHTML = '<p class="wishlist-empty">Your wishlist is empty.</p>';
      return;
    }

    body.innerHTML = items.map(item => {
      const available = (item.variants || []).filter(v => v.available);
      const variantUI = available.length
        ? `<div class="wishlist-variants">
            ${available.map(v => `<button type="button" data-wishlist-add="${esc(v.id)}">${esc(v.title)}</button>`).join('')}
           </div>`
        : '<span class="wishlist-sold-out">SOLD OUT</span>';

      return `<article class="wishlist-item" data-wishlist-item="${esc(item.id)}">
        <a class="wishlist-item-image" href="${esc(item.url)}"><img src="${esc(item.image)}" alt="${esc(item.title)}"></a>
        <div class="wishlist-item-copy">
          <div class="wishlist-item-top">
            <div>
              <a class="wishlist-item-title" href="${esc(item.url)}">${esc(item.title)}</a>
              <span class="wishlist-item-price">${esc(item.price)}</span>
            </div>
            <button type="button" class="wishlist-remove" data-wishlist-remove="${esc(item.id)}" aria-label="Remove ${esc(item.title)}">×</button>
          </div>
          <span class="wishlist-add-label">ADD TO CART</span>
          ${variantUI}
        </div>
      </article>`;
    }).join('');
  };

  const renderAll = () => {
    const items = read();
    updateCount(items);
    updateCardButtons(items);
    renderDrawer(items);
  };

  const addVariant = async variantId => {
    if (!variantId) return;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id: Number(variantId), quantity: 1})
      });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.description || 'Unable to add item');
      }
      if (window.SixToGo && window.SixToGo.refreshCart) {
        await window.SixToGo.refreshCart(true);
      }
    } catch (err) {
      alert(err.message || 'Unable to add item');
    }
  };

  document.addEventListener('click', event => {
    const wish = event.target.closest('[data-wishlist-toggle]');
    if (wish) {
      event.preventDefault();
      event.stopPropagation();
      const card = wish.closest('[data-wishlist-card]');
      const item = cardData(card);
      if (!item) return;
      const items = read();
      const idx = items.findIndex(i => String(i.id) === String(item.id));
      if (idx >= 0) items.splice(idx, 1);
      else items.unshift(item);
      write(items);
      return;
    }

    const hoverCart = event.target.closest('[data-hover-cart]');
    if (hoverCart) {
      event.preventDefault();
      event.stopPropagation();
      const card = hoverCart.closest('.product-card');
      const panel = $('.quick-size-panel', card);
      const variants = cardData(card)?.variants?.filter(v => v.available) || [];

      if (variants.length === 1) {
        addVariant(variants[0].id);
      } else if (panel) {
        panel.hidden = false;
      }
      return;
    }

    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      const id = remove.dataset.wishlistRemove;
      write(read().filter(i => String(i.id) !== String(id)));
      return;
    }

    const add = event.target.closest('[data-wishlist-add]');
    if (add) {
      addVariant(add.dataset.wishlistAdd);
    }
  });

  window.addEventListener('storage', renderAll);
  document.addEventListener('DOMContentLoaded', renderAll);
  renderAll();
})();

/* Home fallback wishlist support.
   Normally the six Home cards resolve to real EP.xx Shopify products above.
   This only handles a card safely if a merchant has not yet created/resolved it. */
document.addEventListener('click', event => {
  const button = event.target.closest('[data-demo-wishlist]');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();

  const key = 'sixToGoWishlistV1';
  let items = [];
  try { items = JSON.parse(localStorage.getItem(key) || '[]'); } catch {}

  const id = 'demo-' + (button.dataset.demoId || '');
  const existing = items.findIndex(item => String(item.id) === id);

  if (existing >= 0) {
    items.splice(existing, 1);
    button.classList.remove('is-active');
  } else {
    items.unshift({
      id,
      title: button.dataset.demoTitle || '',
      url: button.dataset.demoUrl || '#',
      image: button.dataset.demoImage || '',
      price: button.dataset.demoPrice || '',
      variants: []
    });
    button.classList.add('is-active');
  }

  localStorage.setItem(key, JSON.stringify(items));
  window.dispatchEvent(new Event('storage'));
});

/* 6IX TO GO — product size guide */
(() => {
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-size-guide-open]');
    if (open) {
      event.preventDefault();
      const scope = open.closest('.pdp-info') || document;
      const dialog = scope.querySelector('[data-size-guide-dialog]');
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }

    const close = event.target.closest('[data-size-guide-close]');
    if (close) {
      const dialog = close.closest('[data-size-guide-dialog]');
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }
  });

  document.addEventListener('click', event => {
    const dialog = event.target.closest('[data-size-guide-dialog]');
    if (dialog && event.target === dialog && typeof dialog.close === 'function') {
      dialog.close();
    }
  });
})();

